    <header class="page-head">
      <div>
        <h1 class="page-title">My Linked Institutions</h1>
        <p class="page-subtitle">Review institutions linked to your profile and dispute accounts you do not recognise.</p>
      </div>
    </header>

    <section class="section-stack">
      <article class="detail-card" *ngFor="let institution of institutions">
        <div class="list-row">
          <div>
            <h3 class="section-title section-title-tight">{{ institution.name }}</h3>
            <p class="label">Account number: {{ institution.accountNumber }}</p>
            <p class="label">Profile last synced: {{ institution.lastSync }}</p>
          </div>
          <div class="inline-actions">
            <span class="status-chip">{{ institution.status }}</span>
            <button class="btn btn-danger" type="button">Dispute account</button>
          </div>
        </div>
      </article>
    </section>
